import { StateResultsProvided, connectStateResults } from 'react-instantsearch-core';
import { useTranslation } from '~/shared/utils';
import { StyledCounterHeader } from './styled';

type CategorieFiltersProps = {
    spacing?: 'default' | 'header';
} & StateResultsProvided;

const CustomResultsCount = (props: CategorieFiltersProps) => {
    const { translate } = useTranslation();

    return (
        <StyledCounterHeader variant="caption" spacing={props.spacing}>
            {translate('commerce.products')} ({props.searchResults?.nbHits || 0})
        </StyledCounterHeader>
    );
};

export const ResultsCount = connectStateResults<CategorieFiltersProps>(CustomResultsCount);

